import React from 'react';

import { observer } from 'mobx-react';
import { Container } from '@mui/material';

import { angularizeWithProviders } from '../../../../../shared/providers';
import { CorporateAccountsTable } from './CorporateAccountsTable/CorporateAccountsTable';
import { CorporateAccountsModal } from './CorporateAccountsModal/CorporateAccountsModal';
import { CorporateAccountsTabTitle } from './CorporateAccountsTabTitle/CorporateAccountsTabTitle';
import { corporateAccountsStore } from '../../../../stores/corporateAccountsStore';

const NgzCorporateAccountsControlTab = observer(() => {
  const { isModalOpened } = corporateAccountsStore;

  return (
    <Container>
      <CorporateAccountsTabTitle />
      <CorporateAccountsTable />
      {isModalOpened && <CorporateAccountsModal />}
    </Container>
  );
});

angularizeWithProviders(
  NgzCorporateAccountsControlTab,
  'ngzCorporateAccountsControlTab',
  {},
);

export { NgzCorporateAccountsControlTab };
